<template>
  <div>
    <div class="container">
        <!-- 页面头部 -->
        <div class="header">
            <h1>隐私政策</h1>
            <div class="dates">
                <p><strong>生效日期：</strong> 2026年2月6日</p>
            </div>
        </div>

        <!-- 隐私政策正文 -->
        <div class="content">
            <p>KABI China（以下简称“应用程序”）由费森尤斯卡比（中国）投资有限公司（与北京费森尤斯卡比医药有限公司、费森尤斯卡比华瑞制药有限公司一起，简称“费森尤斯卡比”或“我们”）运营，仅提供给公司员工（下称“您”）使用的移动应用程序。用于日常办公、沟通协作、流程审批、信息查询等内部工作目的。</p>

            <p>费森尤斯卡比十分重视您的个人信息隐私权益。当您使用本应用程序时，费森尤斯卡比将会收集、使用、存储、共享、跨境传输您的个人信息。因此，在开始使用本应用程序前，请您务必仔细阅读本隐私政策，以了解我们处理和保护您个人信息的具体方式。</p>
            <p>本隐私政策将帮助您了解以下内容：</p>
            <h1>一、相关定义</h1>
            <h1>二、我们收集您哪些个人信息</h1>
            <h1>三、我们如何使用您的个人信息</h1>
            <h1>四、Cookies文件</h1>
            <h1>五、我们如何共享您的个人信息</h1>
            <h1>六、我们如何存储您的个人信息</h1>
            <h1>七、您如何访问和管理自己的个人信息</h1>
            <h1>八、我们如何保护您的个人信息</h1>
            <h1>九、未成年人个人信息保护</h1>
            <h1>十、本政策如何更新</h1>
            <h1>十一、如何联系我们</h1>
            <h2>一、相关定义</h2>
            <p>个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。通过这些信息，能单独或与其他信息相结合确定和识别个人信息主体，例如姓名、身份证号码、工作单位、职位，或电话号码。</p>
            <p>敏感个人信息是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。对于敏感个人信息，我们将会以<em>加粗下划线</em>的方式提示您注意，请您谨慎考虑后向我们提供。对于此类信息，我们将采取更加严格的保护措施，避免信息的泄露和非法使用。</p>
            <h2>二、我们收集您哪些个人信息</h2>
            <table cellspacing="0" cellpadding="0" width="100%">
                <tr>
                    <th>序号</th>
                    <th width="25%">信息类别</th>
                    <th>涉及的个人信息字段</th>
                    <th>设备权限</th>
                </tr>
                <tr>
                    <td>1.</td>
                    <td colspan="3"><strong>必要信息</strong></td>
                </tr>
                <tr>
                    <td>1.1.</td>
                    <td>身份信息</td>
                    <td>员工ID、姓名、部门、职位、手机号</td>
                    <td>/</td>
                </tr>
                <tr>
                    <td>1.2.</td>
                    <td>账户信息</td>
                    <td>公司邮箱、工号、登录凭证</td>
                    <td>/</td>
                </tr>
                <tr>
                    <td>1.3.</td>
                    <td>设备信息</td>
                    <td>设备型号、操作系统、IP地址、位置信息</td>
                    <td>/</td>
                </tr>
                <tr>
                    <td>2.</td>
                    <td colspan="3"><strong>业务信息</strong></td>
                </tr>
                <tr>
                    <td>2.1.</td>
                    <td>工作数据</td>
                    <td>任务记录、审批流程</td>
                    <td>/</td>
                </tr>
                <tr>
                    <td>2.2.</td>
                    <td>文件资料</td>
                    <td>上传的文档、图片、附件</td>
                    <td>/</td>
                </tr>
                <tr>
                    <td>2.3.</td>
                    <td>操作日志</td>
                    <td>访问时间、操作记录、系统日志</td>
                    <td>/</td>
                </tr>
            </table>
            <h2>三、我们如何使用您的个人信息</h2>
            <p>我们将严格遵守法律法规及与您的约定，将收集的信息用于以下目的：</p>
            <p>（一）账户管理与认证： 创建、管理您的账号，进行身份验证、安全防范；</p>
            <p>（二）提供核心服务： 实现内部通讯、流程审批、信息发布、考勤管理、日程安排等应用程序核心功能；</p>
            <p>（三）运维与安全： 用于运营统计分析、故障诊断、数据安全审计，以维护和改进服务；</p>
            <p>（四）允许您访问、使用费森尤斯卡比应用程序的相关服务；</p>
            <p>（五）为您提供与本应用程序或其他您所需服务相关的客户支持及问题解决服务；</p>
            <p>（六）公司合规管理及审计之目的；</p>
            <p>（七）其他经您授权及许可的目的。</p>
            <h2>四、Cookies文件</h2>
            <p>我们可能通过Cookies或同类技术获取和使用您的信息，并将该等信息存储为日志信息。我们使用Cookies仅为实现以下功能或服务：</p>
            <table cellspacing="0" cellpadding="0" width="100%">
                <tr>
                    <th>Cookie类型</th>
                    <th>功能说明</th>
                    <th>有效期</th>
                </tr>
                <tr>
                    <td>必要Cookies</td>
                    <td>维持登录状态、保障系统安全</td>
                    <td>会话期间</td>
                </tr>
                <tr>
                    <td>分析Cookies</td>
                    <td>统计功能使用频率、优化体验</td>
                    <td>90天</td>
                </tr>
            </table>
            <p>我们所使用的Cookies文件不包含任何个人信息。</p>
            <p>如您对我们所使用的Cookies文件有顾虑，可以通过浏览器设置拒绝或管理Cookies拒绝必要Cookies可能影响系统正常使用。</p>
            <h2>五、我们如何共享您的个人信息</h2>
            <p><strong>（一）委托处理</strong></p>
            <p>除本隐私政策已说明的情形或您另行同意的情形外，我们不会将您的个人信息用于其他目的，也不会向任何第三方共享您的个人信息，法律法规另有规定的除外。尽管如此，我们可能会委托符合法律法规及行业技术标准的第三方合作方或服务提供商代为处理您的个人信息，以便支持费森尤斯卡比运营。为保护您的个人信息安全，我们对服务供应商采取了适当的技术和管理措施；同时，我们要求服务供应商严格遵守保密义务，除为提供相关服务所必需外，不得使用或披露您的个人信息。</p>
            <p><strong>（二）共享</strong></p>
            <p>我们将对您提供给我们的个人信息采取保密措施，但为实现本政策所述目的，我们可能在必要范围内将您的个人信息共享给如下第三方：</p>
            <p>（1）费森尤斯卡比的关联公司，以便实现我们的全球统一管理。有关费森尤斯卡比集团关联公司的信息，您可通过费森尤斯卡比集团的官方网站查看https://www.fresenius-kabi.com/；</p>
            <p>（2）根据中国或其它国家/地区的法律法规，我们必须向其披露您的个人信息的机构和人员，包括监管及执法机关等。</p>
            <p>在上述情况下共享您的个人信息（包括但不限于可能向境外传输您个人信息的情形）时，我们将严格遵守中国相关法律法规的要求，确保您的个人信息安全。</p>
            <h2>六、我们如何存储您的个人信息</h2>
            <p>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</p>
            <p><strong>（一）您的个人信息会存储多久？</strong></p>
            <p>我们仅在为实现上述目的的必要期限或法律、行政法规规定或政府监管要求的存储期限（以较长者为准）内保存您的个人信息，到期后我们将会删除或匿名化处理您的个人信息。具体而言，该等确定保存期限的标准包括：（1）我们与您保持持续关系并向您提供相关服务所需的时间；（2）我们是否有法律义务存储您的个人信息；或（3）我们是否需要应对诉讼或监管调查，执行与您相关的劳务协议等。</p>
            <h2>七、您如何访问和管理自己的个人信息</h2>
            <p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利: </p>
            <p><strong>(一)访问、复制您的个人信息</strong></p>
            <p>您有权访问、复制您的个人信息。</p>
            <p><strong>(二)更正您的个人信息</strong></p>
            <p>当您发现我们处理的关于您的个人信息存在错误时，您有权要求我们做出更正。</p>
            <p><strong>(三)删除您的个人信息</strong></p>
            <p>如存在下列情形之一的，您有权向我们提出删除个人信息的请求：（1）处理目的已实现，或者为实现处理目的不再必要；（2）法定或约定的存储期限已届满（但中国法律法规有其他要求的除外）；（3）基于您的同意对个人信息进行处理的，您撤回同意；（4）我们违反中国法律法规或者违反约定处理您的个人信息；（5）中国法律法规规定的其他情形。</p>
            <p><strong>(四)撤回您的授权同意</strong></p>
            <p>您有权撤回您的授权同意。当您撤回授权同意后，我们将不再处理相应的个人信息。但您撤回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
            <p><strong>(五)响应您的请求</strong></p>
            <p>除上述列举的权利外，我们依法保障适用法律法规规定的其他个人信息权利，例如限制处理个⼈信息、逝者近亲属权利、要求我们对本隐私政策进行解释说明的权利等。如果您想进行如上操作、行使其他法定的个人信息权利，请发送电子邮件至DataProtection.China@fresenius-kabi.com，我们将尽快审核所涉问题，并在15个工作日或中国法律法规规定的期限内答复您的请求。请您知悉，为了保护您和他人的隐私，我们可能需要在处理您的请求之前核实您的身份（要求您提供书面资料或其他方式）。</p>
            <p>请注意，在以下情形中，我们将无法响应您的请求：(1)与我们履行法律法规规定的义务相关的；(2)与国家安全、国防安全直接相关的；(3)与公共安全、公共卫生、重大公共利益直接相关的；(4)与刑事侦查、起诉、审判和执行判决等直接相关的；(5)我们有充分证据表明您存在主观恶意或滥用权利的；(6)响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；(7)涉及商业秘密的；(8)其他法律法规规定的情形。如决定不响应您的请求，我们会向您告知该决定的理由；如您对理由存在异议，可以通过本政策披露的联系方式联系我们。</p>
            <h2>八、我们如何保护您的个人信息</h2>
            <p>我们已采取了必要的符合国家标准和业界标准的安全措施，以保护您的个人信息免受未经授权的访问、篡改、泄露、毁损或丢失，确保个人信息处理活动符合中国法律法规的规定。更多关于费森尤斯卡比中国信息安全的情况，请参见费森尤斯卡比中国官网数据保护声明“我们的安全措施”部分。</p>
            <h2>九、未成年人个人信息保护</h2>
            <p>18周岁及以上的费森尤斯卡比员工。请您不要以任何方式通过本应用程序向我们提交任何不满18周岁的未成年人的个人信息。</p>
            <h2>十、本政策如何更新</h2>
            <p>在遵守适用法律法规且不损害您合法权益的前提下，费森尤斯卡比保留随时修订本政策（包括修改、增补或删除部分条款）的权利。任何政策条款的修订，我们均会通过本应用程序发布更新后的隐私政策进行公告，以便您及时了解政策变更内容。</p>
            <h2>十一、如何联系我们</h2>
            <p>如果您对本隐私政策或您的个人信息保护相关事宜有任何疑问、投诉、建议或希望行使个人信息主体相关权利，请发送邮件至DataProtection.China@fresenius-kabi.com与我们联系。</p>

        </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  
  data() {
    return {
      
    };
  },
  computed: {
  },
  created() {
    window.document.title = this.$t('message.PrivacyPolicy');
  },
  beforeCreate() {
      
  },
  beforeDestroy() {
  },
  mounted() {
  },
  methods: {
    
    
  },
};
</script>

<style scoped>
/* --- 容器样式 --- */
.container {
    max-width: 800px;
    margin: 40px auto;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}
/* --- 头部样式 --- */
.header {
    text-align: center;
    padding-bottom: 30px;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 30px;
}
.header h1 {
    font-size: 28px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 10px;
}
.header .dates {
    font-size: 14px;
    color: #6c757d;
}
/* --- 正文样式 --- */
.content {
    padding: 0 10px;
}
.content h2 {
    font-size: 20px;
    font-weight: 600;
    color: #212529;
    margin-top: 35px;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid #0063be;
}
.content h1 {
    font-size: 15px;
    font-weight: 600;
    color: #343a40;
    margin-top: 25px;
    margin-bottom: 10px;
}
.content p {
    margin-bottom: 15px;
    text-indent: 2em;
    font-size: 15px;
    color: #495057;
}
.content strong {
    color: #212529;
    font-weight: 600;
}
.content ul {
    list-style-type: disc;
    margin-left: 25px;
    margin-bottom: 15px;
}
.content li {
    margin-bottom: 8px;
    font-size: 15px;
    color: #495057;
}
.content a {
    color: #0063be;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s;
}
.content a:hover {
    color: #66b1ff;
    text-decoration: underline;
}
.contact-info {
    background-color: #f1f8ff;
    border-left: 4px solid #0063be;
    padding: 15px 20px;
    margin-top: 20px;
    border-radius: 0 8px 8px 0;
}
.contact-info p {
    margin-bottom: 5px;
    font-size: 15px;
}
em{font-weight: 600;text-decoration: underline;font-style: normal;}
table{border-left:1px solid #e9ecef;border-bottom:1px solid #e9ecef;margin:0 0 15px 0;}
table th{background-color: #f1f8ff;border-top: 1px solid #e9ecef;border-right: 1px solid #e9ecef;padding:8px 0;text-align: center;}
table td{border-top: 1px solid #e9ecef;border-right: 1px solid #e9ecef;padding:8px}
/* --- 页脚样式 --- */
.footer {
    text-align: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #e9ecef;
    font-size: 14px;
    color: #6c757d;
}
/* --- 响应式调整 --- */
@media (max-width: 768px) {
    .container {
        margin: 20px auto;
        padding: 15px;
    }
    .header h1 {
        font-size: 24px;
    }
    .content {
        padding: 0 5px;
    }
    .content h2 {
        font-size: 18px;
        margin-top: 30px;
    }
    .content h3 {
        font-size: 16px;
        margin-top: 20px;
    }
    .content p,
    .content li {
        font-size: 14px;
    }
}
</style>
